import {

    FaListUl,

    FaWallet,

} from "react-icons/fa";

import styles from "./ExpenseSummaryBar.module.css";

const ExpenseSummaryBar = ({

    totalCount = 0,

    totalAmount = 0,

    activeFilterCount = 0,

}) => {

    const hasFilter = activeFilterCount > 0;

    const formattedCount = Number(

        totalCount ?? 0

    ).toLocaleString("fa-IR");

    const formattedAmount = Number(

        totalAmount ?? 0

    ).toLocaleString("fa-IR");

    return (

        <div className={styles.container}>

            <div className={styles.card}>

                <div className={styles.header}>

                    <FaListUl

                        className={`${styles.icon} ${

                            hasFilter

                                ? styles.iconActive

                                : ""

                        }`}

                    />

                    <span className={styles.label}>

                        {

                            hasFilter

                                ? "نتایج فیلتر"

                                : "تعداد هزینه‌ها"

                        }

                    </span>

                </div>

                <div className={styles.value}>

                    {formattedCount}

                </div>

                {

                    hasFilter &&

                    <div className={styles.filterBadge}>

                        {activeFilterCount}

                        &nbsp;

                        فیلتر فعال

                    </div>

                }

            </div>

            <div className={styles.card}>

                <div className={styles.header}>

                    <FaWallet

                        className={`${styles.icon} ${

                            hasFilter

                                ? styles.iconActive

                                : ""

                        }`}

                    />

                    <span className={styles.label}>

                        {

                            hasFilter

                                ? "جمع هزینه‌های نتایج"

                                : "جمع هزینه‌ها"

                        }

                    </span>

                </div>

                <div className={styles.amount}>

                    {formattedAmount}

                    <small>

                        تومان

                    </small>

                </div>

            </div>

        </div>

    );

};

export default ExpenseSummaryBar;